module.exports = __webpack_public_path__ + "img/zoltan-tasi-vHnVtLK8rCc-unsplash.c3d6de27.jpg";